/**
 * Wait for X ms
 * @param {Number} ms
 */
export const wait = async ms => {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
};

/**
 * Wait for Promises
 * @param {Array} promises
 */
export const waitFor = async (...promises) => Promise.all(promises);

/**
 * Runs an asynchronous function and tracks its elapsed time.
 *
 * @param {Function} fn - The asynchronous function to execute.
 * @param {Function} [callback] - An optional callback function that receives the timer object.
 *                                It is called initially and then every second with the updated elapsed time.
 * @returns {Promise<any>} A promise that resolves with the result of the executed function.
 */
export const runWithTimer = async (fn, callback = () => {}) => {
    const timer = {
        start: Date.now(),
        elapsed: 0
    };

    callback(timer);

    const intervalId = setInterval(() => {
        timer.elapsed = Math.floor((Date.now() - timer.start) / 1000);
        callback(timer);
    }, 1000);

    try {
        return await fn();
    } finally {
        clearInterval(intervalId);
    }
};
